import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMPENSATION_PLANS_ACTION_TYPE } from '../actions';

const initialState = [];

const compensationPlansReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMPENSATION_PLANS_ACTION_TYPE.GET_PLANS:
        return payload || initialState;

      case COMPENSATION_PLANS_ACTION_TYPE.CREATE_PLAN:
        draft.push(payload);
        break;

      case COMPENSATION_PLANS_ACTION_TYPE.UPDATE_PLAN:

      case COMPENSATION_PLANS_ACTION_TYPE.APPROVE_CHANGE: {
        const index = draft.findIndex(plan => plan.id === payload.id);

        if (index !== -1) {
          draft[index] = payload;
        }

        break;
      }

      case COMPENSATION_PLANS_ACTION_TYPE.DELETE_PLAN:
        return draft.filter(plan => plan.id !== payload);

      case COMPENSATION_PLANS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default compensationPlansReducer;
